"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var getHashFromString = function getHashFromString(str, range) {
  var sum = 0;
  for (var i = 0; i < str.length; i++) {
    sum += +str.charCodeAt(i).toString(2);
  }
  return sum % range + 1;
};

exports.default = getHashFromString;